<template>
    <div id="guoqin">
        <ul class="list">
            <li @click="active = 47" :class="{active:active == 47}">
                <h2>10.1</h2>
                <p>充10.1元送10.1元</p>
                <p>2020个（书币+书豆）</p>
                <img src="http://static.yuread.cn/upload/activity/guoqin/gou.png" alt="">
            </li>
            <li @click="active = 48" :class="{active:active == 48}">
                <h2>36</h2>
                <p>充36元送40元</p>
                <p>7600个（书币+书豆）</p>
                <img src="http://static.yuread.cn/upload/activity/guoqin/gou.png" alt="">
            </li>
            <li @click="active = 49" :class="{active:active == 49}">
                <h2>55</h2>
                <p>充55元送66元</p>
                <p>12100个（书币+书豆）</p>
                <img src="http://static.yuread.cn/upload/activity/guoqin/gou.png" alt="">

            </li>
            <li @click="active = 50" :class="{active:active == 50}">
                <h2>99</h2>
                <p>充99元送121元</p>
                <p>22000个（书币+书豆）</p>
                <img src="http://static.yuread.cn/upload/activity/guoqin/gou.png" alt="">

            </li>

        </ul>
        <p class="tip">
            活动期间每位用户每项充值送书豆优惠仅有一次机会
        </p>
        <div class="btn">
            <img src="http://static.yuread.cn/upload/activity/guoqin/btn.png" alt="" @click="doRecharge">
        </div>
    </div>
</template>

<script>
    export default {
        name: "Guoqing",
        data(){
            return {
                active:47,
            }
        },methods:{
            doRecharge(){

                let userInfo = this.$store.getters.getUserInfo;
                if(!userInfo.id){
                    this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    return ;
                }

                var loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                });
                //先查询用户是否参与过首充优惠
                this.axios.post('/api/recharge/actives',{
                    type : 17,
                    rid : this.active,
                }).then(r => {
                    loading.close()
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                    }
                })
            }
        }
    }
</script>

<style lang="less">
#guoqin{min-height: 1500px;height:100%;background-image: url("http://static.yuread.cn/upload/activity/guoqin/gq.jpg");background-size:100% 100%;overflow: auto;position: relative;
    ul{margin-top: 500px;display: flex;justify-content: space-between;flex-wrap: wrap;padding: 50px;
        li{width: 300px;height: 295px;background-image: url("http://static.yuread.cn/upload/activity/guoqin/t.png");background-size: 100%;position: relative;
            img{display: none;width: 33px;height:33px;}
        }
        .active{
            img{display: block;position:absolute;top:90px;right:30px;}
        }
        h2{text-align: center;margin-top: 100px;font-size: 68px;color: #f3e5d3;}
        p{text-align: center;font-size: 24px;color: #fff;}
    }
    .tip{text-align: center;color: #eabd96;font-size: 24px;}
    .btn{text-align: center;margin-top: 30px;
        img{width: 321px;height: 87px;}
    }
}
</style>
